import { Modal } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

import ButtonCustom from '../../../../../../../../../../Components/ButtonCustom'
import { Warning } from '../../../../../../../../../../Components/CustomUi/warning'
import { ContainerAlerta } from './styled'

interface Props {
  abrir: boolean
  fechar: () => void
}

/**
 * Aviso exibido ao abrir uma OS em modo EDITAR: alterar a OS enquanto a coleta
 * está em execução no campo quebra a sincronização do app. Portado da versão em
 * produção, onde dispara ao final do carregamento da OS para edição — não
 * aparece ao criar nem ao clonar.
 */
export const AlertaEdicao: React.FC<Props> = ({ abrir, fechar }) => {
  return (
    <Modal
      open={abrir}
      onCancel={fechar}
      closeIcon={false}
      destroyOnClose
      footer={false}
      width='30%'
      zIndex={9999}
      title={
        <ButtonCustom type='tertiary' danger icon={<FontAwesomeIcon icon={faXmark} />} onClick={fechar}>
          Fechar
        </ButtonCustom>
      }
    >
      <ContainerAlerta>
        <Warning type='warning'>
          Atenção: Ao editar essa OS comprometerá a sincronização no app caso esteja ocorrendo a
          execução no campo.
        </Warning>
      </ContainerAlerta>
    </Modal>
  )
}
